export default {
    title: 'Unterschrift',
    description: 'Mit Ihrer Unterschrift bestätigen Sie die Richtigkeit und Vollständigkeit der Angaben.',
    saveSuccess: 'Unterschrift wurde erfolgreich gespeichert.',
    invalidRoute: 'Ungültiger Link',
    isSigned: 'Unterschrift existiert bereits.'
}